import React from 'react'
import { Grid } from "@mui/material"

import {
	AnalyzerEvolutionModal,
	AnalyzersTable,
	MarketBandChart,
	PositionContext,
	PositionKpis,
	PositionVerdict,
	RankEvolutionChart
} from "Pages/AnalyzersV2/@components"
import { isAnalyzerLoading, responseData } from "Pages/AnalyzersV2/@signals"
import useAnalyzerData from "Pages/AnalyzersV2/@hooks/useData"
import { sortRowsByAveragePrice } from "Pages/AnalyzersV2/@components/Table/@utils"
import { findCurrency, findMainName } from "Pages/AnalyzersV2/Position/@utils"
import { NoDataFound, AppResultsSkeleton } from "@components"


export default function PositionContent() {
	const {
		tableData,
		tableColumns,
		dataEmpty,
		evolutionData,
		chartContent,
		noResults,
		mainData,
		marketChartData
	} = useAnalyzerData(responseData.value)

	if (noResults) {
		return <NoDataFound/>
	}

	if (dataEmpty && !isAnalyzerLoading.value) return null

	const mainName = findMainName(tableData)
	const currency = findCurrency(tableData)
	const totalBrands = mainData?.avgMarketRank?.lenCompetitors || chartContent.keySeries?.length
	// Table only — charts and Excel keep the backend's alphabetical order.
	const sortedTableData = sortRowsByAveragePrice(tableData)

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<PositionContext
				mainName={mainName}
				office={chartContent.officeData}
				columns={tableColumns}
				totalBrands={totalBrands}
				currency={currency}
			/>
		</Grid>
		<Grid item xs={12}>
			<PositionKpis mainData={mainData} currency={currency}/>
		</Grid>
		<Grid item xs={12}>
			<PositionVerdict mainData={mainData} mainName={mainName}/>
		</Grid>
		<Grid item xs={12}>
			<MarketBandChart
				marketChartData={marketChartData}
				totalBrands={totalBrands}
			/>
		</Grid>
		<Grid item xs={12}>
			<RankEvolutionChart
				chartData={chartContent.chartData}
				keySeries={chartContent.keySeries}
			/>
		</Grid>
		<Grid item xs={12}>
			{isAnalyzerLoading.value && <AppResultsSkeleton rows={7} columns={8}/>}
			{!isAnalyzerLoading.value &&
				<AnalyzersTable
					tableData={sortedTableData}
					columns={tableColumns}
					evolutionData={evolutionData}
					isPosition
					mainName={mainName}
					// Broker mode groups rows by provider, not by web, so the site
					// favicon would not describe the row. Read from the response and
					// not from the signal: flipping the toggle does not refetch, and
					// the loaded rows still belong to the previous mode.
					hideIcon={!!responseData.value?.isProviderMode}
				/>}
		</Grid>
		<Grid item xs={12}>
			<AnalyzerEvolutionModal/>
		</Grid>
	</Grid>
}
